import { useTranslation } from 'react-i18next'
import PestanasAdmin from '../../components/admin/PestanasAdmin'

// Administración > Áreas y especialidades: the org chart and the cargo list,
// one menu entry with two tabs.
export default function AdminGrupoAreas({ children }) {
  const { t } = useTranslation('nav')
  return (
    <>
      <PestanasAdmin tabs={[
        { to: '/admin/areas', label: t('items.adminAreas') },
        { to: '/admin/cargos', label: t('items.adminCargos') },
      ]} />
      {children}
    </>
  )
}
